<template>
  <div class="info-text">
    <span class="icon" v-html="InfoSvg"></span><span v-html="props.text"></span>
  </div>
</template>

<script setup>
import InfoSvg from '~/layers/base/assets/icons/info.svg?raw'

const props = defineProps({
  text: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.info-text {
  opacity: 0.7;
  font-size: 1.1rem;
  letter-spacing: 0.11px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon {
  opacity: 0.7;
}
</style>
